import { FiInfo } from 'react-icons/fi';
import './Home.css';

const HomeNoShop = () => {
    return (
        <div className="homeNoShopContainer">
            <FiInfo className="homeNoShopIcon" aria-hidden />
            <h3 className="homeNoShopText">
                Una vez completados los datos de tu local podrás acceder a la carta y obtener el QR para descargar.
            </h3>
        </div>
    );
};

export default HomeNoShop;
